import { render, staticRenderFns } from "./CarNew.vue?vue&type=template&id=126dad2b"
import script from "./CarNew.vue?vue&type=script&lang=ts"
export * from "./CarNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports